__turbopack_context__.v({
  "buttonContainer": "bOWDnG_buttonContainer",
  "buttonRow": "bOWDnG_buttonRow",
  "headerIcon": "bOWDnG_headerIcon",
  "number": "bOWDnG_number",
  "numberContainer": "bOWDnG_numberContainer",
  "referralLink": "bOWDnG_referralLink",
  "referralLinkContainer": "bOWDnG_referralLinkContainer",
  "referralLinkSection": "bOWDnG_referralLinkSection",
  "stepperDottedLine": "bOWDnG_stepperDottedLine",
  "stepperRoot": "bOWDnG_stepperRoot",
  "stepperSection": "bOWDnG_stepperSection",
  "stepperText": "bOWDnG_stepperText",
  "text": "bOWDnG_text",
  "title": "bOWDnG_title",
  "titleSection": "bOWDnG_titleSection",
});
